import { groupBy } from 'lodash';
import { toastConfig } from 'config';
import { App, Spin } from 'antd';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { encodeQueryParamData } from 'utils/utils';
import { useEffect, useMemo, useState } from 'react';
import controls from 'assets/images/icons/deactivated.svg';
import ComptrollerConfirmModal from '../ComptrollerConfirmModal';
import { activeInactiveStatus, TableStatusMap } from 'pages/globals/global';
import ComptrollerDataTable from '../comptroller-table/ComptrollerDataTableV8';
import IndeterminateCheckbox from 'components/@extended/IndeterminateCheckbox';
// import { useDeleteVerticalMutation } from 'store/features/comptroller/comptrollerApi';
import { useWorkFlowDesignBulkActiveMutation, useWorkFlowDesignBulkDeactivateMutation } from 'store/features/process/processApi';

const WorkflowList = ({ navigate, selectedTabName, isLoading, setReloadTable, workflowList = [] }) => {
	const { message: messageApi } = App.useApp();
	// const [DeleteVertical, { data: deleteVertical }] = useDeleteVerticalMutation();
	const [workflowDesignActiveHandler, { data: workflowActiveHandleData }] = useWorkFlowDesignBulkActiveMutation();
	const [workflowDesignDeactivateHandler, { data: workflowDeactivateHandleData }] = useWorkFlowDesignBulkDeactivateMutation();

	const [value, setValue] = useState(null);
	const [modalData, setModalData] = useState({});
	const [filterData, setFilterData] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [submitData, setSubmitData] = useState(null);
	const [rowSelection, setRowSelection] = useState({});
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);

	const { profileData } = useSelector((state) => state?.profile);

	useEffect(() => {
		if (rowSelection?.length) {
			let arr = [];

			rowSelection?.forEach((item) => {
				arr.push(item.original);
			});

			setSelectedRowKeys(groupBy(arr, ({ activationStatus }) => activationStatus));
		}
	}, [rowSelection]);

	const activeDeactiveHandle = (moduleStatus) => {
		let arr = [];

		if (moduleStatus === 'Active') {
			setValue('deactivated');
			setModalData({
				head: 'Module',
				label:
					rowSelection?.length > 1 ? (
						<p>
							{' '}
							Do you want to <b style={{ fontSize: '1rem' }}>deactivate</b> all?
						</p>
					) : (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>deactivate</b> this vertical?
						</p>
					),
			});

			if (selectedRowKeys[moduleStatus]) {
				selectedRowKeys[moduleStatus]?.map((item) => {
					arr.push({
						id: item?.id,
						companyCode: profileData?.creatorOrganizationId,
						code: item?.code,
						menu: item?.menu,
						name: item?.name,
						activationStatus: 'Inactive',
					});
					return item;
				});
			}
		} else if (moduleStatus === 'Inactive') {
			setValue('activated');

			setModalData({
				head: 'Module',
				label:
					rowSelection?.length > 1 ? (
						<p>
							{' '}
							Do you want to <b style={{ fontSize: '1rem' }}>active</b> all?
						</p>
					) : (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>active</b> this vertical?
						</p>
					),
			});

			if (selectedRowKeys[moduleStatus]) {
				selectedRowKeys[moduleStatus]?.map((item) => {
					arr.push({
						id: item?.id,
						companyCode: profileData?.creatorOrganizationId,
						menu: item?.menu,
						code: item?.code,
						name: item?.name,
						activationStatus: 'Active',
					});
					return item;
				});
			} else {
				selectedRowKeys['W-I-P']?.map((item) => {
					arr.push({
						id: item?.id,
					});

					return item;
				});
			}

			if (selectedRowKeys['NEW_INACTIVE']) {
				selectedRowKeys['NEW_INACTIVE']?.map((item) => {
					arr.push({
						id: item?.id,
						companyCode: profileData?.creatorOrganizationId,
						menu: item?.menu,
						code: item?.code,
						name: item?.name,
						activationStatus: 'Active',
					});
					return item;
				});
			}
		}

		if (arr?.length !== rowSelection?.length) {
			messageApi.error({
				content: 'Your request is inconsistent with selection.',
				icon: <img src={controls} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
			});
		} else {
			setSubmitData(arr);
			setShowModal(true);
		}
	};

	const deleteHandle = (data) => {
		setValue('delete');
		setModalData({
			head: 'Vertical',
			label:
				rowSelection?.length > 1 ? (
					<p>
						{' '}
						Do you want to <b style={{ fontSize: '1rem' }}>delete</b> all?
					</p>
				) : (
					<p>
						Do you want to <b style={{ fontSize: '1rem' }}>delete</b> this vertical?
					</p>
				),
		});
		setSubmitData(data);
		setShowModal(true);
	};

	const handleActionSubmit = () => {
		if (submitData) {
			if (value === 'activated') {
				workflowDesignActiveHandler({ data: submitData });

				setValue(null);
			} else if (value === 'deactivated') {
				workflowDesignDeactivateHandler({ data: submitData });

				setValue(null);
			}

			// else if (value === 'delete') {
			// 	let arr = [];

			// 	submitData?.forEach((item) => {
			// 		arr.push(item?.id);
			// 	});

			// 	DeleteVertical({ ids: arr });
			// 	setValue(null);
			// }
		}
	};

	useEffect(() => {
		if (workflowActiveHandleData?.status === 'SUCCESS') {
			let message = submitData?.length > 1 ? `Success! ${submitData?.length} rows ${value}` : `Success! ${submitData?.length} row ${value}`;

			toast.success(message, toastConfig);
			setReloadTable((val) => !val);
		} else if (workflowActiveHandleData?.status === 'FAILED') {
			toast.error('Workflow Status Updation Error!', toastConfig);
		}
	}, [workflowActiveHandleData]);

	useEffect(() => {
		if (workflowDeactivateHandleData?.status === 'SUCCESS') {
			let message = submitData?.length > 1 ? `Success! ${submitData?.length} rows ${value}` : `Success! ${submitData?.length} row ${value}`;

			toast.success(message, toastConfig);
			setReloadTable((val) => !val);
		} else if (workflowDeactivateHandleData?.status === 'FAILED') {
			toast.error('Workflow Status Updation Error!', toastConfig);
		}
	}, [workflowDeactivateHandleData]);

	const COLUMNS = useMemo(
		() => [
			{
				id: 'Selection',
				header: ({ table }) => (
					<IndeterminateCheckbox
						{...{
							checked: table.getIsAllRowsSelected(),
							indeterminate: table.getIsSomeRowsSelected(),
							onChange: table.getToggleAllRowsSelectedHandler(),
							sx: { color: '#858585', padding: '0px' },
						}}
					/>
				),
				cell: ({ row }) => (
					<IndeterminateCheckbox
						{...{
							checked: row.getIsSelected(),
							disabled: !row.getCanSelect(),
							indeterminate: row.getIsSomeSelected(),
							onChange: row.getToggleSelectedHandler(),
						}}
					/>
				),
			},
			{
				key: 'name',
				header: 'Solution Name',
				accessorKey: 'name',
				cell: (cell) => {
					return cell?.row?.original?.solution?.name;
				},
			},
			{
				key: 'code',
				header: 'Solution Code',
				accessorKey: 'code',
				cell: (cell) => {
					return cell?.row?.original?.solution?.code;
				},
			},
			{
				key: 'module',
				header: 'Module Code',
				accessorKey: 'module',
				cell: (cell) => {
					return cell?.row?.original?.solution?.module;
				},
			},
			{
				key: 'subModule',
				header: 'Sub-module Code',
				accessorKey: 'subModule',
				cell: (cell) => {
					return cell?.row?.original?.solution?.subModule;
				},
			},
			{
				key: 'activationStatus',
				header: 'Status',
				accessorKey: 'activationStatus',
				cell: (cell) => {
					return activeInactiveStatus(TableStatusMap[cell.row.original.activationStatus]);
				},
			},
		],
		[]
	);

	return (
		<Spin spinning={isLoading}>
			<ComptrollerDataTable
				COLUMNS={COLUMNS}
				bulkDelete={false}
				DATA={workflowList}
				xlsxFileName="work-flow"
				mountHeaderControls
				rowSelection={rowSelection}
				deleteHandle={deleteHandle}
				setFilterData={setFilterData}
				selectedTabName={selectedTabName}
				setRowSelection={setRowSelection}
				activeDeactivateHandle={activeDeactiveHandle}
				onClickHandler={(row) => {
					const params = encodeQueryParamData({ id: row?.id });

					navigate(`/comptroller/work-flow/view/${params}`);
				}}
			/>

			{showModal && (
				<ComptrollerConfirmModal showModal={showModal} setShowModal={setShowModal} handleSubmit={handleActionSubmit} modalData={modalData} />
			)}
		</Spin>
	);
};

export default WorkflowList;
